import { createContext, useContext } from 'react'

const defaultValues = {
  isDarkMode: false,
  canUseDarkMode: false,
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  setIsDarkMode: dark => undefined
}

const DarkModeContext = createContext(defaultValues)

export function useDarkModeContext() {
  return useContext(DarkModeContext)
}

export default DarkModeContext
